<script setup lang="ts">
import type { PipedriveUser } from '@models/auth/pipedriveUser';
import { computed, toRef } from 'vue';
import { type Color, getColorValue } from '@global-types/colors';
import IconStatusWhite from '@icons/ph_status-white.svg';
import Icon from './Icon.vue';

const props = withDefaults(defineProps<{
  user: PipedriveUser,
  size?: number,
  isOnline?: boolean
}>(), {
  size: 24,
  isOnline: false,
});

const initials = computed<string>(() => {
  const { firstname } = props.user;
  return firstname[0].toUpperCase();
  // @todo Standby for now, specs to come
  // const lastname = props.user.lastname;
  // return firstname[0].toUpperCase() + lastname[0].toUpperCase();
});

const user = toRef(() => props.user);

const colors: Color[] = [ 'green', 'blue', 'red', 'yellow', 'orange', 'black', 'purple' ];

const backgroundColor = computed<string>(() => {
  const letter = initials.value[0];
  if (!letter) {
    return 'black';
  }
  const normalized = letter.toUpperCase().charCodeAt(0);
  const index = normalized % colors.length;
  return getColorValue(colors[index]);
});
</script>

<template>
  <div class="user-picture">
    <div
      v-if="user.picture_url"
      class="user-picture__image picture-image"
    >
      <img
        class="picture-image__media"
        :style="{ width: `${size}px`, height: `${size}px` }"
        :src="user.picture_url"
        :alt="user.firstname"
      >
    </div>
    <div
      v-else
      class="user-picture__initials"
      :style="{ width: `${size}px`, height: `${size}px`, backgroundColor }"
    >
      {{ initials }}
    </div>
    <Icon
      v-if="isOnline"
      :svg="IconStatusWhite"
      class="user-picture__online-status"
    />
  </div>
</template>
